import type { MapBriefHandoff } from "../map/mapTypes";

const mapHandoffs = new Map<string, MapBriefHandoff>();

export function setTransientMapBrief(
  websiteId: string,
  handoff: MapBriefHandoff,
): void {
  mapHandoffs.set(websiteId, handoff);
}

export function transientMapBrief(websiteId: string): MapBriefHandoff | null {
  return mapHandoffs.get(websiteId) ?? null;
}
